import { getProductDetails } from "../../apiCalls/urlFunction";
import { isDiscountedProduct } from "../../hooks/utilsFn/utilsFn";

export const validateOutOfStock = (product) => {
  let response = {
    outOfStock: false,
    rangeDenomination: false,
    fixedDenomination: false,
  };

  if (product?.denominations?.[0]?.type === "FIXED") {
    response.outOfStock = false;
    response.rangeDenomination = false;
    response.fixedDenomination = true;
    return response;
  }

  if (product?.denominations?.[0]?.type === "RANGE") {
    response.outOfStock = false;
    response.rangeDenomination = true;
        response.fixedDenomination = false;
    return response;
  }

  response.outOfStock = true;
  response.rangeDenomination = false;
      response.fixedDenomination = false;
  return response;
};

export const isProductLive = (status) => {
  if (status === "ACTIVE") {
    return true;
  }
  return false;
};

export const fetchProductById = async (urlId) => {
  try {
    return await getProductDetails(urlId);
  } catch (error) {}
};

export const isDenominationAvailable = (denoData) => {
  let response = {
    isDenominationAvailableStatus: true,
  };

  if (!denoData?.length) {
    response.isDenominationAvailableStatus = false;
  }

  return response;
};

export const createDenominationData = (data) => {
  const newDenoData = data?.denominations?.map((item) => {
    return {
      AMOUNT: item?.amount,
      DISCOUNT: item?.discount || data?.discount || 0,
      QUANTITY: 0,
      TOTAL: 0,
      MAX_LIMIT: item?.maxLimit || data?.max_quantity || 5,
      DENOM_TYPE: item?.denomType || "FIXED",
      PRODUCT_CODE: item?.PRODUCTCODE || null,
      PRODUCT_GUID: item?.ProductGuid || null,
      PRODUCT_ID: data?.publicId || null,
      SUB_PRODUCT_ID: item?.subproduct_id || null,
      SKU_ID: item?.skuID || null,
      ISCASHBACK_PRODUCT: item?.denomType === "CASHBACK",
      PRODUCT_TYPE: data?.productType || null,
      CASHBACK_AMOUNT: item?.denomType === "CASHBACK" ? item?.discount : null,
      DENOMINATION_ID: item?.thirdPartyId || null,

      ...item,
    };
  });
  return newDenoData;
};

export const productDetailApiCall = async (urlId) => {
  let response = {
    status: true,
    message: null,
    data: null,
  };
  try {
    const apiResponse = await getProductDetails(urlId);

    if (!apiResponse?.status) {
      response.status = false;
      response.message = apiResponse?.message;
      return response;
    }

    let product = { ...(apiResponse?.data || {}) };

    if (!product) {
      return {
        status: false,
        message: "Product not found",
        data: null,
      };
    }

    // Discount Check
    const { productType, discount } = isDiscountedProduct(product?.discount);
    product.productType = productType;
    product.discount = discount;
    product.isCashbackProduct = productType === "Cashback";

    // Stock Check
    const { outOfStock, rangeDenomination, fixedDenomination } = validateOutOfStock(product);
    product.rangeDenomination = rangeDenomination;
    product.outOfStock = outOfStock;
    product.fixedDenomination=fixedDenomination;

    // Denomination data have
    if (!outOfStock && !rangeDenomination) {
      const newDeno = createDenominationData(product);
      product.newDeno = newDeno;
    }

    if (!outOfStock && rangeDenomination) {
      product.min_price = product?.denominations?.[0]?.minAmount || 0;
      product.max_price = product?.denominations?.[0]?.maxAmount || 0;
    }

    response.data = product;
    return response;
  } catch (error) {
    console.error(error);
  }
};
